import { envs } from 'application/envHandler'
import apiClient from 'core/api'
import { BootstrapConfiguration, BootstrapInit, BootstrapVersion } from '../types'

export async function fetchVersions(): Promise<Array<BootstrapVersion>> {
  const { data } = await apiClient.get(`${envs.REACT_APP_API_URL}/bootstrap/versions`)
  return data
}

export async function fetchPlatforms(version: string): Promise<Array<string>> {
  const { data } = await apiClient.get(
    `${envs.REACT_APP_API_URL}/bootstrap/versions/${version}/platforms`
  )
  return data
}

export async function createPlatform(version: string, platformId: string): Promise<void> {
  await apiClient.post(`${envs.REACT_APP_API_URL}/bootstrap/versions/${version}/platforms`, {
    platformId,
  })
}

export async function fetchInitConfiguration(
  version: string,
  platform: string
): Promise<BootstrapConfiguration> {
  const { data } = await apiClient.get(
    `${envs.REACT_APP_API_URL}/bootstrap/versions/${version}/platforms/${platform}`
  )
  return data
}

export async function saveInitConfiguration(
  version: string,
  platform: string,
  init: BootstrapInit
): Promise<void> {
  const payload: BootstrapInit = {
    version: init.version,
    ccUrl: init.ccUrl,
    recoveryUrl: init.recoveryUrl,
    minVersion: init.minVersion,
    referencedBuild: init.referencedBuild,
  }

  await apiClient.put(
    `${envs.REACT_APP_API_URL}/bootstrap/versions/${version}/platforms/${platform}/init`,
    payload
  )
}

export async function deleteBuild(
  version: string,
  platform: string,
  fileName: string
): Promise<void> {
  await apiClient.delete(
    `${envs.REACT_APP_API_URL}/bootstrap/versions/${version}/platforms/${platform}/builds/${encodeURIComponent(fileName)}`
  )
}

type PresignedUrl = {
  uploadUrl: string
  requiredHeaders: Record<string, string>
}

export async function uploadBuild(
  version: string,
  platform: string,
  file: File,
  onProgress: (percentage: number) => void,
  signal?: AbortSignal
): Promise<void> {
  const { data }: { data: PresignedUrl } = await apiClient.post(
    `${envs.REACT_APP_API_URL}/bootstrap/versions/${version}/platforms/${platform}/builds/presigned-url`,
    { fileName: file.name },
    { signal }
  )

  await apiClient.put(data.uploadUrl, file, {
    headers: {
      ignoreCommonHeaders: true,
      'Content-Type': 'application/octet-stream',
      ...data.requiredHeaders,
    },
    signal,
    onUploadProgress: (event) =>
      onProgress(event.total ? Math.round((event.loaded / event.total) * 100) : 0),
  })
}
